import React, { Component } from "react";
import { getMe, setRuta } from "./redux/modules/usuario/usuario";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import Navbar from "./common/components/Navbar/NavbarContainer";
import Sidebar from "./common/components/Sidebar/Sidebar";

// funciona para determinar si puede acceder a la vista
function isAuthenticated() {
    return localStorage.getItem("token");
}

class PrivateRouteBase extends Component {
    componentWillMount(props) {
        this.props.setRuta(window.location.href);
        this.props.getMe();
    }

    render() {
        const { component: Component, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={props =>
                    isAuthenticated() ? (
                        <div>
                            <Navbar />
                            <Sidebar />

                            <div className="content-wrapper">
                                <Component {...props} />
                            </div>
                        </div>
                    ) : (
                            <Redirect
                                to={{
                                    pathname: "/login",
                                    state: { from: props.location }
                                }}
                            />
                        )
                }
            />
        );
    }
}

const mstp = state => ({});

const mdtp = { getMe, setRuta };

const ProtectedRoute = connect(
    mstp,
    mdtp
)(PrivateRouteBase);

export default ProtectedRoute;
